export default __webpack_public_path__ + "static/media/menu_bell.dcdc16a2.svg";